import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import { toast } from 'react-toastify';
import { axiosPublic } from '../../service/axiosPublic';
import { axiosPrivate } from '../../service/axiosPrivate';

const userInfoLS = JSON.parse(localStorage.getItem('userInfo'));

const initialState = {
  isLoading: false,
  userInfo: userInfoLS || null,
};

const mergeUserInfo = (prev, next) => {
  const merged = { ...(prev || {}), ...next };
  localStorage.setItem('userInfo', JSON.stringify(merged));
  return merged;
};

export const login = createAsyncThunk('auth/login', async user => {
  try {
    const response = await axiosPublic.post('token/', user);
    const decoded = jwtDecode(response.data.access);
    const userInfo = { ...response.data, ...decoded };
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    return userInfo;
  } catch (error) {
    toast.error(error.message);
    return null;
  }
});

export const fetchMe = createAsyncThunk('auth/fetchMe', async (_, { getState, rejectWithValue }) => {
  try {
    const response = await axiosPrivate.get('users/me/');
    const prev = getState().auth.userInfo || {};
    return mergeUserInfo(prev, response.data);
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || 'Ruxsatlarni yuklashda xato');
  }
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: state => {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    },
  },
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.userInfo = action.payload ? { ...action.payload } : null;
        state.isLoading = false;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.userInfo = action.payload;
      });
  },
});

const { reducer, actions } = authSlice;

export const { logout } = actions;

export default reducer;
